export default {
	SET_CONFIRM_LOGIN(state, data) {
		state.confirmLogin = data
	},
	SET_SHOW_WJX(state, data) {
		state.showWjx = data
	},
	SET_IS_COLLAPSE(state, data) {
		state.isCollapse = data
	},
	SET_SHOW_RECYCLE(state, data) {
		state.showRecycle = data
	},
	SET_PROJECT_INFO(state, data) {
		state.projectInfo = data
	},
	SET_IS_REFRESH(state, data) {
		state.isRefresh = data
	},
	SET_PROJ_LIST_DATA(state, data) {
		state.projListData = data
	}
}
